import React, { useState, useEffect } from "react";
import { Button, Empty, Form, Input,Select,Card, Divider } from "antd";
import "./settings.scss";
import LeavesConfigTable from "../LeavesConfigTable";
import HolidaysConfigTable from "../HolidaysConfigTable";
import useTeamTimeSheetStore from "../../store/teamtimesheet";
import useProjectStore from "../../store/projectModal.store";

const leavesTitles = [
  "Select",
  "S. No.",
  "Leave Type",
  "Max Avaliable",
  "Carry Forward",
];
const holidayTitles = [
  "Select",
  "S. No.",
  "Holiday Name",
  "Location",
  "Date",
];

function LeavesConfig({exist,configData,configViewHandler}) {

    const [encodedLeavesSet, setEncodedLeavesSet] = useState([{}]);
    const [encodedHolidaysSet, setEncodedHolidaysSet] = useState([{}]);
    const { leaveConfigSettingReq } = useTeamTimeSheetStore();
    const [currentLeaveList, setCurrentLeaveList] = useState(null);
    const [currentHolidayList, setCurrentHolidayList] = useState(null);
    const [configName, setConfigName] = useState("");    
    const {getProjects,groupnamelist } = useProjectStore();     

    function getTimeNow() {
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate;
    } 
  const selectGroupList = Object.keys(groupnamelist || {}).map(key => ({
      value: groupnamelist[key],
      label: key,
      }));     
    var leavesListNew = [
        { select: "",id: 1,leavetype: "Earned Leave (EL)", maxleaves: 6, carryforward: 6 },
        { select: "",id: 2,leavetype: "Privilege Leave (PL)", maxleaves: 6, carryforward: 6 },
        { select: "",id: 3,leavetype: "Sick Leave (SL)", maxleaves: 6, carryforward: 0 },      
        { select: "",id: 4,leavetype: "Maternity Leave (ML)", maxleaves: 6, carryforward: 0 },
        { select: "",id: 5,leavetype: "Paternity Leave (PtL)", maxleaves: 6, carryforward: 0 },
        { select: "",id: 6,leavetype: "Special Leave (SPL)", maxleaves: 6, carryforward: 0 },
        { select: "",id: 7,leavetype: "Restricted Holiday (RH)", maxleaves: 2, carryforward:0},  
        { select: "",id: 8,leavetype: "Bereavement Leave (BL)", maxleaves: 6, carryforward: 0 },  
        { select: "",id: 9,leavetype: "Bonus Leaves (Bonus Leave)", maxleaves: 6, carryforward: 0 },  
        { select: "",id: 10,leavetype: "Comp Off", maxleaves: 6, carryforward: 0 },  
        { select: "",id: 11,leavetype: "Other Leaves", maxleaves: 6, carryforward: 0 }, 
        { select: "",id: 12,leavetype: "LOP", maxleaves: 724, carryforward: 0 },  
    ]; 

    var holidayListNew = [
        { select: "",id: 1,holidayname: "New Year",location:"All",  date: getTimeNow() }, //dd-mm-yyyy
        { select: "",id: 2,holidayname: "Republic Day",location:"All",  date: getTimeNow()  },
        { select: "",id: 3,holidayname: "Makar Sankranti",location:"All",  date: getTimeNow()  },
        { select: "",id: 4,holidayname: "Holi",location:"All",  date: getTimeNow() },      
        { select: "",id: 5,holidayname: "Raksha Bandhan",location:"All",  date: getTimeNow() },
        { select: "",id: 6,holidayname: "Janmashtami",location:"All",  date: getTimeNow()  },
        { select: "",id: 7,holidayname: "Independance Day",location:"All",  date: getTimeNow() },
        { select: "",id: 8,holidayname: "Diwali", location:"All", date: getTimeNow() },  
        { select: "",id: 9,holidayname: "Diwali- Lakshmi Puja", location:"All", date:getTimeNow() },  
        { select: "",id: 10,holidayname: "Christmas",location:"All",  date: getTimeNow() },  
    ]; 


    const initData = () =>{
        if(exist){
                leavesListNew =configData?.leavesarray?.map((item, idx) => {
                    return {
                             select: "",
                             id: idx + 1,
                             leavetype: item.leavetype,
                             maxleaves: item.maxleaves,
                             carryforward: item.carryforward,
                    }}) 
                holidayListNew =configData?.holidaysarray?.map((item, idx) => {
                    return {
                              select: "",
                              id: idx + 1,
                              holidayname: item.holidayname,
                              location: item.location,
                              date: item.date,
                    }}) 
                                
        }  
        setCurrentLeaveList([...leavesListNew]) 
        setCurrentHolidayList([...holidayListNew])              
    }

    useEffect(() => {
        initData()
        var initJson=initLeavesJson()
        setEncodedLeavesSet(() => [...initJson])

        var initJson2=initHolidaysJson()
        setEncodedHolidaysSet(() => [...initJson2])

        let date = new Date();
        let timestamp = date.getTime();
        setConfigName("Config - " + timestamp) 

        getProjects()
    }, []);
    
          

    function getTimeNowYear() {
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        return year;
    }      
    const reInitencodedJsonLeaves = (json,action) => {
        var idexToModify = 0
        var currentLeavesSet =encodedLeavesSet
        for(let idx = 0; idx < json.leavesListNew?.length; idx++){
            if (action =="UPDATE" ) {
                idexToModify = json.leavesListNew[idx].leaveid
                currentLeavesSet[idexToModify]={};
                currentLeavesSet[idexToModify].leaveid =json.leavesListNew[idx].leaveid;
                currentLeavesSet[idexToModify].leavetype =json.leavesListNew[idx].leavetype;
                currentLeavesSet[idexToModify].maxleaves =json.leavesListNew[idx].maxleaves;
                currentLeavesSet[idexToModify].carryforward =json.leavesListNew[idx].carryforward;                
            }                       
        } 
        if (action =="UPDATE" ){
           console.log("Encoded Leaves in leave config",currentLeavesSet)


            leavesListNew =currentLeavesSet?.map((item, idx) => {
                        return {
                                select: "",
                                id: idx + 1,
                                leavetype: item.leavetype,
                                maxleaves: item.maxleaves,
                                carryforward: item.carryforward,
            }})         
           setCurrentLeaveList([...leavesListNew])            
           setEncodedLeavesSet(() => [...currentLeavesSet])
        }   
    }
    
    const getTotalAllocatedLeaves = () =>{
        var tLeaves =0
        for(let idx = 0; idx < encodedLeavesSet.length; idx++){
            if(encodedLeavesSet[idx].leavetype != "LOP"){
                tLeaves = tLeaves + encodedLeavesSet[idx].maxleaves
            }
        }          
        return tLeaves
    }    
    const initLeavesJson = () =>{
        var leavesarray =[{}];
        for(let idx = 0; idx < leavesListNew.length; idx++){
            leavesarray[idx]={};
            leavesarray[idx].leaveid =idx;
            leavesarray[idx].leavetype =leavesListNew[idx].leavetype;
            leavesarray[idx].maxleaves =leavesListNew[idx].maxleaves;
            leavesarray[idx].carryforward =leavesListNew[idx].carryforward;
        }          
        return leavesarray
    }

    const reInitencodedJsonHolidays = (json,action) => {
        var idexToModify = 0
        var currentHolidaysSet =encodedHolidaysSet
        var newHoliday =[{}]
        var holidaysAfterRemoved =encodedHolidaysSet
        for(let idx = 0; idx < json.holidayarray.length; idx++){
            if (action =="ADD" ) {
                action = "ADD"
                newHoliday[idx]={};
                newHoliday[idx].holidayid =json.holidayarray[idx].holidayid;
                newHoliday[idx].holidayname =json.holidayarray[idx].holidayname;
                newHoliday[idx].location =json.holidayarray[idx].location;
                newHoliday[idx].date =json.holidayarray[idx].date;               
            } else if (action =="UPDATE" ) {
                idexToModify = json.holidayarray[idx].holidayid
                currentHolidaysSet[idexToModify]={};
                currentHolidaysSet[idexToModify].holidayid =json.holidayarray[idx].holidayid;
                currentHolidaysSet[idexToModify].holidayname =json.holidayarray[idx].holidayname;
                currentHolidaysSet[idexToModify].location =json.holidayarray[idx].location;
                currentHolidaysSet[idexToModify].date =json.holidayarray[idx].date;                 
            } else if (action =="DELETE" ) {
                idexToModify = json.holidayarray[idx].holidayid 
                holidaysAfterRemoved = holidaysAfterRemoved.filter((item)=> item.holidayid != idexToModify)
            }                        
        } 
        
        console.log("check both", currentHolidaysSet,currentHolidayList)

        if (action =="UPDATE" ){
           setEncodedHolidaysSet(() => [...currentHolidaysSet])
           holidayListNew =currentHolidaysSet?.map((item, idx) => {
                    return {
                              select: "",
                              id: idx + 1,
                              holidayname: item.holidayname,
                              location: item.location,
                              date: item.date,
                    }}) 
           setCurrentHolidayList(() => [...holidayListNew]) 
        }
        if (action =="ADD" ){
           var newHolidaysSet = [...encodedHolidaysSet,...newHoliday]
           setEncodedHolidaysSet(() => [...newHolidaysSet])
           holidayListNew =newHolidaysSet?.map((item, idx) => {
                    return {
                              select: "",
                              id: idx + 1,
                              holidayname: item.holidayname,
                              location: item.location,
                              date: item.date,
                    }}) 
           setCurrentHolidayList(() => [...holidayListNew]) 
        }
        if (action =="DELETE" ){
           setEncodedHolidaysSet(() => [...holidaysAfterRemoved])
           holidayListNew =holidaysAfterRemoved?.map((item, idx) => {
                    return {
                              select: "",
                              id: idx + 1,
                              holidayname: item.holidayname,
                              location: item.location,
                              date: item.date,
                    }}) 
           setCurrentHolidayList(() => [...holidayListNew]) 
        }          
    }

    const initHolidaysJson = () =>{
        var harray =[{}];
        for(let idx = 0; idx < holidayListNew.length; idx++){
            harray[idx]={};
            harray[idx].holidayid =idx;
            harray[idx].holidayname =holidayListNew[idx].holidayname;
            harray[idx].location =holidayListNew[idx].location;
            harray[idx].date =holidayListNew[idx].date;
        }          
        return harray
    }

    const encodeJson = (value) =>{

        const userData = JSON.parse(localStorage.getItem("userDetails"));
        let encodedJsonValues ={};

        //console.log("Config Data and Leaves---------->",configData, encodedLeavesSet)
        if (exist == false){
            encodedJsonValues.action   = "New"  
            encodedJsonValues.name           = value?.name == null?configName:value.name
            encodedJsonValues.saturdaymode   = value.saturdaymode == null?"Holiday":value.saturdaymode 
            encodedJsonValues.year   = value.year == null?getTimeNowYear():value.year   
            encodedJsonValues.groupname   = value.groupname == null?"":value.groupname               
        }else{
            encodedJsonValues.action   = "Update"
            encodedJsonValues.qhlconfigid   = configData.qhlconfigid
            encodedJsonValues.name           = value?.name == null?configData?.name:value.name
            encodedJsonValues.saturdaymode   = value?.saturdaymode == null?configData?.saturdaymode:value.saturdaymode  
            encodedJsonValues.year   = value?.year == null?configData?.year:value.year 
            encodedJsonValues.groupname   = value.groupname == null?configData.groupname:value.groupname                 
        }
        encodedJsonValues.totalleaves     = getTotalAllocatedLeaves(encodedLeavesSet)
        encodedJsonValues.totalholidays   = encodedHolidaysSet.length          

        //get the current date
        let newDate = getTimeNow()
        encodedJsonValues.updatedby = {}
        encodedJsonValues.updatedby.qhuid= userData.qhuid;
        encodedJsonValues.updatedby.updatedbyname= userData.username;
        encodedJsonValues.updatedby.updatedon    = newDate;    


        encodedJsonValues.leavesreq ={}
        encodedJsonValues.leavesreq.leavesarray = encodedLeavesSet
 

        encodedJsonValues.holidaysreq ={}
        encodedJsonValues.holidaysreq.holidaysarray = encodedHolidaysSet 
        if (exist == false){
            encodedJsonValues.holidaysreq.action   = "ADD"
        }else{
            encodedJsonValues.holidaysreq.action   = "Update"
        }            

        return encodedJsonValues
    }

    const handleFormSubmit = (value) => {
        var jasonValues= encodeJson(value)
        console.log("Encoded data", jasonValues)
        leaveConfigSettingReq({jasonValues})

        if(configViewHandler != null){
           configViewHandler("existingconfig",-1)
        }
 
    }

    if((currentLeaveList == null ) || (currentHolidayList == null)) return <></>
    return (
        <div className="evaluation-setup-container">

            <div className="e-members-wrapper"> 
                <div className="e-members-list-heading">
                    Leaves Settings
                </div> 
                {currentLeaveList?.length > 0 ? (
                       <LeavesConfigTable
                            titleList={leavesTitles}
                            data={currentLeaveList}
                            config ={`50px 0.5fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr`}
                            handleCallBack = {reInitencodedJsonLeaves}
                            modifyTable ={false}
                        />
                    ) : (
                        <Empty style={{ margin: "60px" }} />
                    )
                } 
                <div className="e-members-list-heading">
                    Holidays Settings
                </div> 
                {currentHolidayList?.length > 0 ? (
                       <HolidaysConfigTable
                            titleList={holidayTitles}
                            data={currentHolidayList}
                            config ={`50px 0.5fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr`}
                            handleCallBack = {reInitencodedJsonHolidays}
                            modifyTable ={true}
                        />
                    ) : (
                        <Empty style={{ margin: "60px" }} />
                    )}                                   
                 <div className="e-members-list-heading">
                     General Settings
                </div>  
                <div className="e-members-list-item">                
                    <Form
                        name="evaluation-form"
                        justify="start"
                        layout="vertical"
                        autoComplete="off"
                        onFinish={handleFormSubmit}
                    >
                        <Form.Item
                            required={true}
                            name="name"
                            label="Leave Configuration Name"
                        >
                            <Input required={true} 
                                  defaultValue= { exist?configData?.name:configName} 
                                  className="e-members-input"/>
                        </Form.Item>                        

                        <Form.Item
                            name="saturdaymode"
                            required={true}
                            label="Saturday Working Status"
                        >
                            <Select
                                    required={true}
                                    name="saturdaymode"
                                    className="e-members-input" 
                                    defaultValue={exist?configData?.saturdaymode:'Holiday'}                           
                                    options={[
                                        { value: 'Half Day Working', label: 'Half day Working' },
                                        { value: 'Full Day Working', label: 'Full Day Working' },
                                        { value: 'Holiday', label: 'Holiday' },
                                        { value: '1st and 3rd Working', label: '1st and 3rd Working' },
                                        { value: '2nd and 4th Working', label: '2nd and 4th Working' },
                                    ]}
                            />                             
                        </Form.Item>  
                        <Form.Item
                            name="year"
                            required={true}
                            label="Year"
                        >
                            <Select
                                    required={true}
                                    name="year"
                                    className="e-members-input" 
                                    defaultValue={exist?configData?.year:getTimeNowYear()}                           
                                    options={[
                                        { value: 2025, label: 2025 },
                                        { value: 2026, label: 2026 },
                                        { value: 2027, label: 2027 },
                                    ]}
                            />                             
                        </Form.Item> 

                        <Form.Item
                            required={true}
                            name="groupname"
                            label="Group/BU Name"
                        >
                          <Select
                            required={true} 
                            className="e-members-input"
                            defaultValue= { exist?configData?.groupname:""}
                            options={selectGroupList}
                          />                                  
                        </Form.Item>                               

                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            {exist?"Update":"Create Now"}
                        </Button>
                    </Form>                      
                </div>   
                <div>
                    <Divider/>
                </div>                                              
            </div>            

        </div>
    );
}

export default LeavesConfig;
